module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"create-carrier-service":"Create Carrier Service","update-carrier-service":"Update Carrier Service","carrier-service-updated":"Carrier Service updated","failed-update-carrier-service":"Failed to update carrier service","carrier-service-created":"Carrier Service created","failed-create-carrier-service":"Failed to create carrier service"}}')
  delete Component.options._Ctor
}
